import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=ff3c6056&"
import script from "./Expenses.vue?vue&type=script&lang=js&"
export * from "./Expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3c6056')) {
      api.createRecord('ff3c6056', component.options)
    } else {
      api.reload('ff3c6056', component.options)
    }
    module.hot.accept("./Expenses.vue?vue&type=template&id=ff3c6056&", function () {
      api.rerender('ff3c6056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expenses.vue"
export default component.exports